var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame-wrap"},[_c('iframe',{attrs:{"src":_vm.host,"frameborder":"0","width":"100%","height":"100%"}}),(_vm.slug)?_c('PlayNovelPopup',{attrs:{"slug":_vm.slug},on:{"close":_vm.close}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }